import type { NavigableRouteType } from '@/router/types';

import { instance } from './appRoutes';

export const dashboard = {
  path: `${instance.path}/dashboard`,
  description:
    'The default page to redirect to after sign in which shows pipeline trends, traffic summary, benchmarks, and the most recent closed-won opportunities.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;
